module.exports = __webpack_public_path__ + "media/images/city_img/i-f9d5b4dd92c9b59d249eae81e359e0c2.jpg";